import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeCancelQesSigningMutation as useDeCancelQesSigningMutationType } from "@/modules/patients/detail/conclude/services/de/__generated__/useDeCancelQesSigningMutation.graphql"

const mutation = graphql`
  mutation useDeCancelQesSigningMutation($input: De_cancelQesSigningRequestInput!) {
    de_cancelQesSigningRequest(input: $input) {
      boolean
    }
  }
`

const useDeCancelQesSigningMutation = () => {
  const [commit] = useMutation<useDeCancelQesSigningMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCancelQesSigningMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler] as const
}

export { useDeCancelQesSigningMutation }
